import React = require("react");

import { Button } from "semantic-ui-react";

import { ActionableTask } from "../models";

import { Link } from "redux-little-router";

export const EmployeeCompleteHealthSurveillanceQuestionnaire = (task: ActionableTask) => (
    !task.cancelled &&
    (
        <Link href={`/actions/${task.ohCaseId}/${task.id}/healthSurveillanceQuestionnaire`}>
            <Button content={ task.completed ? "View Questionnaire" : "Complete Questionnaire" } />
        </Link>
    )
);
